import React, { useState, useEffect } from 'react';

import { CloseIcon } from './Styles/Icons';
import {
	InputGroup,
	TextArea,
	ButtonGroup,
	Button,
	FilledErrorButton,
	FlexColumn,
	Dialog,
	DialogActions,
	DialogTitle,
	DialogContent,
	CircularButton,
	ReasonChipRow,
	ReasonChip,
} from './Styles/CancelDialogBox';

import { CancelReasons, COMMENT_MAX_LENGTH } from './Utils';

const CancelDialogBox = ({ open, onTrue, onFalse }) => {
	const [comment, setComment] = useState('');
	const [selectedReason, setSelectedReason] = useState(null);
	const [submitting, setSubmitting] = useState(false);

	const onReasonSelect = (reason) => {
		setSelectedReason(reason);
		setComment(reason);
	};

	const onCommentChange = (value) => {
		setComment(value);
		if (value !== selectedReason)
			setSelectedReason(null);
	};

	const onTrueHandler = async () => {
		if (!comment.trim() || submitting)
			return;

		setSubmitting(true);
		try {
			await onTrue(comment);
		} finally {
			setSubmitting(false);
		}
	};

	const onFalseHandler = () => {
		onFalse();
	};

	useEffect(() => {
		if (open) {
			setComment('');
			setSelectedReason(null);
			setSubmitting(false);
		}
	}, [open]);

	return (
		<Dialog
			open={open}
			onClose={() => onFalseHandler()}
			fullWidth
		>
			<DialogTitle>
				Cancel Item
				<ButtonGroup alignRight>
					<CircularButton
						error
						outline
						onClick={() => onFalseHandler()}
					>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent>
				<FlexColumn>
					<ReasonChipRow>
						{CancelReasons.map((reason) => (
							<ReasonChip
								key={reason}
								label={reason}
								selected={selectedReason === reason}
								onClick={() => onReasonSelect(reason)}
							/>
						))}
					</ReasonChipRow>

					<InputGroup
						label='Reason for cancellation'
						markRequired={true}
						maxLength={COMMENT_MAX_LENGTH}
						inputLength={comment.length}
						message='This comment will be shown to the customer.'
					>
						<TextArea
							name='cancel_comment'
							placeholder='Enter a reason for cancellation'
							value={comment}
							inputProps={{ maxLength: COMMENT_MAX_LENGTH }}
							onChange={(e) => onCommentChange(e.target.value)}
						/>
					</InputGroup>
				</FlexColumn>
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button
						primary
						outline
						onClick={(e) => onFalseHandler()}
					>
						Keep Item
					</Button>
					<FilledErrorButton
						disabled={!comment.trim() || submitting}
						onClick={(e) => onTrueHandler()}
					>
						Cancel Item
					</FilledErrorButton>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

export default CancelDialogBox;
